import { useQuery } from "@tanstack/react-query";
import HubertTipIcon from "../../assets/images/info-icon-violet.svg";
import { fetchContentCollection } from "../../behavior/api/content";
import { PageRoute } from "../../constants";
import { Button, Heading, HorizontalLine, Text } from "../elements";

interface HubertTipProps {
    title: string;
    subtitle: string;
    description: string;
    btnText: string;
}

const HubertTip = ({ title, subtitle, description, btnText }: HubertTipProps) => {
    const { data: contentCollection, isLoading: loading } = useQuery({
        queryKey: ["contentCollection", { tags: ["Dashboard Interview Tips"], limit: 1 }],
        queryFn: fetchContentCollection({
            tags: ["Dashboard Interview Tips"],
            optionalTags: [],
            page: 1,
            limit: 1,
        }),
    });

    const hasContent = !loading && contentCollection?.contents && contentCollection.contents.length > 0;
    const article = hasContent ? contentCollection.contents[0] : undefined;

    return (
        <div className="hubert-tip-wrapper">
            <div className="head-section">
                <img src={HubertTipIcon} className="hubert-tip-icon" />
                <Heading level="h4">{title}</Heading>
            </div>
            <HorizontalLine weight="semi-dark" className="mb-6" />
            <Text size="large" weight="semibold" block className="mb-5">
                {subtitle}
            </Text>
            <Text block className="mb-6">
                {description}
            </Text>
            <Button
                secondary
                to={article ? `${PageRoute.LEARN_WITH_HUBERT_ARTICLE}/${article.id}` : PageRoute.LEARN_WITH_HUBERT}
            >
                {btnText}
            </Button>
        </div>
    );
};

export default HubertTip;
